import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { WarningCircle, CaretRight } from "@phosphor-icons/react";

const fmt = (n) => `€ ${Number(n || 0).toFixed(2).replace(".", ",")}`;

export default function EntityFeesPendingBanner() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/entity-fees/pending-mine").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  return (
    <div className="space-y-2 mb-5" data-testid="entity-fees-pending-banners">
      {items.map((it) => (
        <button
          key={`${it.practice_id}-${it.request_id}`}
          type="button"
          onClick={() => nav(`/marketplace/practices/${it.practice_id}#bollettini`)}
          className="w-full text-left rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 p-4 shadow-sm flex items-center gap-3 hover:bg-amber-100/60 transition-colors"
          data-testid={`entity-fee-banner-${it.practice_id}-${it.request_id}`}
        >
          <div className="w-10 h-10 rounded-full bg-amber-400 text-white flex items-center justify-center shrink-0">
            <WarningCircle size={22} weight="fill" />
          </div>
          <div className="flex-1 min-w-0 text-sm text-slate-800">
            <span className="font-semibold">⚠️ Pagamento diritti ente in attesa</span>
            {" — "}{it.service_name}{it.address && it.address !== "—" ? ` (${it.address})` : ""}{" — "}
            <span className="font-mono font-semibold">{fmt(it.amount)}</span>
            {!it.is_mine && <span className="ml-2 text-[11px] text-amber-800">(collaboratore)</span>}
          </div>
          <CaretRight size={18} className="text-amber-700 shrink-0" />
        </button>
      ))}
    </div>
  );
}
